export default __webpack_public_path__ + "static/media/Mobile.83ab982d.webp";